import MaterialPageTable from "./material-page-table"
/**
 * @deprecated
 */
export default MaterialPageTable
